import React, { PureComponent, useCallback } from 'react';
import { connect } from 'react-redux';

import FormikProvider from '../../../shared/forms/formikProvider.component';
import Modal from '../../../shared/modals/modal.component';
import Form from '../../../shared/forms/form.component';

import schema from './bookToTaxCodeForm.schema';

import { countryTaxTypeOptionsSelector } from '../../../shared/store/selectors';
import { BookToTaxCode } from '../types';
import { SelectOption, Period } from '../../../shared/types';

const ModalTitles = {
  ADD: 'Add Book to Tax Code Description',
  EDIT: 'Edit Book to Tax Code Description',
};

type AddBookToTaxCodeDescriptionModalProps = {
  saveEntity: (
    entityToEdit: BookToTaxCode,
    openForEdit: boolean,
    options: { callback: () => void, keepOpenAfterSaving: boolean }
  ) => void,
  hideModal: () => void,
  period: Period,
  entityToEdit: BookToTaxCode,
  openForEdit: boolean,
  countryTaxTypes: null | SelectOption[],
  isSavingEntity: boolean,
  isVisible: boolean,
};

type AddBookToTaxCodeDescriptionModalState = {
  addAnother: boolean,
};


class AddBookToTaxCodeDescriptionModal extends PureComponent<
  AddBookToTaxCodeDescriptionModalProps,
  AddBookToTaxCodeDescriptionModalState
> {
  state = {
    addAnother: false,
  };

  saveBookToTaxCodeDescription = (
    bookToTaxCodeDescription: Omit<BookToTaxCode, 'periodName'>,
    { setSubmitting, resetForm }: { setSubmitting: (isSubmitting: boolean) => void, resetForm: () => void }
  ) => {
    const { period, saveEntity, openForEdit } = this.props;
    const { addAnother } = this.state;

    this.setState({ addAnother: false }, () => {
      saveEntity({
        ...bookToTaxCodeDescription,
        periodName: period.name,
      }, openForEdit, { callback: resetForm, keepOpenAfterSaving: addAnother });
      setSubmitting(false);
    });
  };

  renderModal = ({ formik, schema }: any ) => {
    const {
      openForEdit,
      countryTaxTypes,
      hideModal,
      isVisible,
      isSavingEntity,
    } = this.props;

    const submit = useCallback(() => {
      this.setState({
        addAnother: false,
      }, () => formik.handleSubmit());
    }, [formik]);

    const submitAndAddAnotherAction = useCallback(() => {
      this.setState({
        addAnother: true,
      }, () => formik.handleSubmit());
    }, [formik]);

    const reset = useCallback(() => {
      hideModal();
      formik.resetForm();
    }, [formik, hideModal]);

    return (
      <Modal
        className="add-book-to-tax-code-description-modal"
        title={openForEdit ? ModalTitles.EDIT : ModalTitles.ADD}
        closeAction={reset}
        dismissText="Cancel"
        dismissAction={reset}
        submitText="Save"
        submitAction={submit}
        isSubmitting={formik.isSubmitting || isSavingEntity}
        submitAndAddAnotherAction={!openForEdit ? submitAndAddAnotherAction : null}
        submitAndAddAnotherText="Save and Add Another"
        isVisible={isVisible}
      >
        <Form
          formik={formik}
          schema={schema}
          openForEdit={openForEdit}
          formContext={{
            countryTaxTypes: countryTaxTypes ? countryTaxTypes : [],
          }}
        />
      </Modal>
    );
  };

  render() {
    const { entityToEdit } = this.props;

    return (
      <FormikProvider
        schema={schema}
        entityToEdit={entityToEdit}
        onSubmit={this.saveBookToTaxCodeDescription as any}
        render={this.renderModal}
      />
    );
  }
}


const mapStateToProps = (state: any) => ({
  countryTaxTypes: countryTaxTypeOptionsSelector(state) as unknown as (null | SelectOption[]),
});


export default connect(mapStateToProps)(AddBookToTaxCodeDescriptionModal);
